module.exports = __webpack_public_path__ + "media/page-1_alt.6ba1043b.mp3";